import type { FC } from "react";
import { useTranslation } from "next-i18next";
import { Col, Row, Grid, Card } from "antd";
import responsiveColumn from "../../../../methods/responsiveColumn";
import Link from "next/link";
import { transformString } from "./utils";
import type { StaticBoxProps } from "../../../../interfaces/globalProps";

export const ComplianceSection4: FC = () => {
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();
  const { t } = useTranslation("compliance");

  const section4Boxes = t("section4_boxes", {
    returnObjects: true,
  }) as StaticBoxProps[];

  return (
    <Row style={{ padding: "50px 0" }} justify='center'>
      <Col
        {...responsiveColumn([18, 19, 20, 22, 23, 23])}
        style={{ textAlign: "center", lineHeight: 1.5 }}
      >
        <div className='orangeTitle'>{t("section4_orange")}</div>
        <h2
          className='section_title'
          style={{ fontSize: screenSize.md ? 48 : 24 }}
        >
          {t("section4_title")}
        </h2>
        <Row justify={"center"} gutter={[30, 20]} style={{ marginTop: 30 }}>
          {section4Boxes?.map((item, index) => {
            return (
              <Col {...responsiveColumn([8, 8, 8, 22, 22, 22])} key={index}>
                <Link
                  style={{
                    color: "#fff",
                    fontSize: 16,
                    fontWeight: screenSize.md ? 500 : 400,
                  }}
                  href={`/tax-compliance/${transformString(item.title)}`}
                >
                  <Card
                    className={"hoverable-tile"}
                    hoverable
                    style={{
                      width: "100%",
                      height: 128,
                      textAlign: "center",
                      background: "#254486",
                      fontWeight: screenSize.md ? 600 : 500,
                      color: "#fff",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "-9px 9px 15px rgb(0 0 0 / 50%)",
                    }}
                  >
                    {item.title}
                  </Card>
                </Link>
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
};
